
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRightArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.316 4.831a1.103 1.103 0 0 1-.046-1.496.96.96 0 0 1 1.317-.133l.097.084 8 7.941c.391.389.42 1.027.084 1.452l-.084.094-8 7.94a.961.961 0 0 1-1.414-.048 1.106 1.106 0 0 1-.04-1.4l.086-.096L15.538 12 8.316 4.831Z",
  stroke: "#fff",
  strokeWidth: 2.2,
  strokeLinejoin: "round",
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.316 4.831a1.103 1.103 0 0 1-.046-1.496.96.96 0 0 1 1.317-.133l.097.084 8 7.941c.391.389.42 1.027.084 1.452l-.084.094-8 7.94a.961.961 0 0 1-1.414-.048 1.106 1.106 0 0 1-.04-1.4l.086-.096L15.538 12 8.316 4.831Z",
  fill: "#000",
  stroke: "#000",
  strokeWidth: 1.5,
  strokeLinejoin: "round",
  strokeLinecap: "round"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\r\n<path d=\"M8.31606 4.83128C7.91315 4.43133 7.89274 3.76127 8.27047 3.33465C8.61914 2.94086 9.18518 2.89215 9.5871 3.20155L9.68394 3.28638L17.6839 11.2275C18.0753 11.616 18.1032 12.2544 17.7678 12.6786L17.6839 12.7725L9.68394 20.7136C9.28103 21.1136 8.6482 21.092 8.27047 20.6653C7.92179 20.2715 7.91237 19.6703 8.22988 19.2656L8.31606 19.1687L15.538 12L8.31606 4.83128Z\" fill=\"none\" stroke=\"white\" stroke-width=\"2.2\" stroke-linejoin=\"round\" stroke-linecap=\"round\"/>\r\n<path d=\"M8.31606 4.83128C7.91315 4.43133 7.89274 3.76127 8.27047 3.33465C8.61914 2.94086 9.18518 2.89215 9.5871 3.20155L9.68394 3.28638L17.6839 11.2275C18.0753 11.616 18.1032 12.2544 17.7678 12.6786L17.6839 12.7725L9.68394 20.7136C9.28103 21.1136 8.6482 21.092 8.27047 20.6653C7.92179 20.2715 7.91237 19.6703 8.22988 19.2656L8.31606 19.1687L15.538 12L8.31606 4.83128Z\" fill=\"black\" stroke=\"black\" stroke-width=\"1.5\" stroke-linejoin=\"round\" stroke-linecap=\"round\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/right-arrow.f38fae04a40314a29f844b0a88f6d261.svg"),
        {
          React: SvgRightArrow,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      